import React from "react";
import "./WeatherPresenter.css";
import { themes } from "../../../../common/themes/themes";
import UserProfileController from "../../../../common/components/UserProfileController";
import CustomDashboardCard from "../../../../common/components/CustomDashboardCard/CustomDashboardCard";

interface IWeatherProps {
  weather: {
    pic: string;
    designation: string;
    name: string;
    card_title?: string;
    awards: string;
  };
}

const WeatherPresenter = ({ weather }: IWeatherProps) => {
  return (
    <>
      <CustomDashboardCard cardSize={{ card_title: "" }} color={themes.primary}>
        <UserProfileController
          reporter={{
            emp_name: weather.name,
            emp_designation: weather.designation,
            emp_pic: weather?.pic,
            manager_award: weather?.awards,
          }}
          isDashboard={true}
        />
      </CustomDashboardCard>
    </>
  );
};

export default WeatherPresenter;
